<template>
	<div class="p-6">
		<div class="vx-row">
			<div
				class="vx-col w-full sm:w-3/3 md:w-3/3 pr-2"
				:class="[{'vx-col w-full sm:w-3/3 md:w-2/3': selectedEvents.length > 0}]"
			>
				<vx-card :title="null" :cardBorder="true" :noShadow="true">
					<span class="g-subtitle" v-text="$t('Schedule.ListofEventsDay')"></span>
					<div class="vx-row mt-4">
						<div class="vx-col">
							<small class="g-label"
								>{{ $t("Schedule.SelectDateToSeeEvents.Text1") }}
								<code>{{ $t("Schedule.SelectDateToSeeEvents.Text2") }}</code>
								{{ $t("Schedule.SelectDateToSeeEvents.Text3") }}
							</small>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								name="start-date"
								v-model="visitsDate"
							></datepicker>
						</div>
						<div class="vx-col">
							<div class="flex flex-wrap items-center justify-start">
								<div>
									<small class="g-object--description"> {{ $t("Schedule.ReassignDate") }}</small>
									<datepicker
										:language="$vs.rtl ? langHe : langEn"
										:disabledDates="disabledDatesTo"
										name="new-date"
										v-model="reassignDate"
									></datepicker>
								</div>
								<div>
									<vx-tooltip :text="$t('general.Clear')">
										<vs-button
											class="mt-6 ml-1"
											v-if="reassignDate"
											icon-pack="feather"
											icon="icon-trash-2"
											color="danger"
											@click.stop="reassignDate = null"
										></vs-button>
									</vx-tooltip>
								</div>
							</div>
						</div>
					</div>
					<VuePerfectScrollbar class="scroll-area mt-1" v-once :settings="settings">
						<event-list :dataEvents="dataEvents" :dataExport="false" />
					</VuePerfectScrollbar>
				</vx-card>
			</div>
			<transition name="slide-fade">
				<div v-if="selectedEvents.length > 0" class="vx-col w-full sm:w-3/3 md:w-1/3 pl-2">
					<vx-card :title="null" :cardBorder="true" :noShadow="true">
						<bread-crumbs
							:title="$t('ResourceList')"
							:subTitle="$t('general.SubtitleReassing')"
							:sizeTitle="18"
							:lineHeightTitle="22"
							:sizeSubTitle="12"
							:lineHeightSubTitle="16"
						>
						</bread-crumbs>
						<resource-list
							ref="ResourceList"
							:title="null"
							componentParent="REASSIGN_EVENTS"
						></resource-list>
					</vx-card>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DateUtils from "@/helpers/DateUtils.js";
import EventList from "./EventList.vue";
import ResourceList from "./ResourceList.vue";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import PopupCustomize from "../../core/components/PopupCustomize";

export default {
	name: "CalendarByDay",
	data() {
		return {
			settings: {
				maxScrollbarLength: 60,
			},
			currentDay: new Date(),
			visitsDate: new Date(),
			reassignDate: null,
			langHe: es,
			langEn: en,
			markerArray: [],
			possitionArray: [],
			newReassigDate: false,
		};
	},
	computed: {
		dataEvents() {
			return this.$store.state.moduleSchedule.events;
		},
		currentResourceId() {
			return !this.$store.state.moduleSchedule ? 0 : this.$store.state.moduleSchedule.currentResourceId;
		},
		selectedEvents() {
			return this.$store.state.moduleSchedule.selectedEvents;
		},
		disabledDatesTo() {
			const date = this.addOrLessDaysToDate(new Date(), -1);
			return {to: new Date(date)};
		},
		disabledDatesFrom() {
			return {from: new Date(this.currentDay)};
		},
	},
	components: {
		PopupCustomize,
		VuePerfectScrollbar,
		Datepicker,
		EventList,
		ResourceList,
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getEvents() {
			this.openLoading();
			const payload = {
				init_date: DateUtils.toDefaultDateTime(this.visitsDate, "YYYY-MM-DD"),
				end_date: DateUtils.toDefaultDateTime(this.visitsDate, "YYYY-MM-DD"),
				resource_id: this.currentResourceId,
			};
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		/**
		 * TODO: Adiciona o resta dias a una fecha espeficada
		 * @Param {String} stringDate fecha en formato string de la cual se va a restar o sumar
		 * @Param {Number} dayNums Entero positivo o negativo
		 */
		addOrLessDaysToDate(stringDate, dayNums) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
	},
	watch: {
		visitsDate(val) {
			this.$store.commit("moduleSchedule/SET_CALENDAR_DATE", DateUtils.toDefaultDateTime(val, "YYYY-MM-DD"));
			this.getEvents();
		},
		reassignDate(val) {
			if (val) {
				this.$store.commit(
					"moduleSchedule/SET_REASSIGNED_DATE",
					DateUtils.toDefaultDateTime(val, "YYYY-MM-DD")
				);
			} else {
				this.$store.commit("moduleSchedule/SET_REASSIGNED_DATE", val);
			}
		},
	},
	mounted() {
		this.visitsDate = this.currentDay;
	},
	created() {
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
		this.$store.commit("moduleSchedule/SET_REASSIGNED_DATE", null);
	},
	beforeDestroy() {
		this.$store.commit("moduleSchedule/CLEAN_SELECTED_EVENTS");
	},
};
</script>

<style lang="scss">
.scroll-area {
	margin: auto;
	width: 100%;
	height: 450px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
	background: chocolate;
}

.slide-fade-enter,
.slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}
</style>
